import * as React from 'react';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import './css/ProductTable.css';
import { Util } from 'src/Util';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#424242',
    color: theme.palette.common.white
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14
  }
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: '#EEEEEE'
  },
  '&:last-child td, &:last-child th': {
    border: 0
  }
}));

export default function ProductTable(invoiceData: any) {
  const invoiceCurrency = invoiceData.invoiceData?.originalCurrency?.currencyName;
  const hardcodedShop = invoiceData.invoiceData?.shopId?._id === '683012d23b5853fdd557c9c2';

  return (
    <>
      <TableContainer sx={{ maxHeight: 400, minHeight: 400 }} component={Paper}>
        <Table aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell sx={{ maxWidth: 80 }}>No.</StyledTableCell>
              <StyledTableCell align="left">Item Description</StyledTableCell>
              {invoiceData.invoiceData?.shopId?._id === "685fb7cb1d830c004fafc932" && (
                <StyledTableCell align="left">Brand Name</StyledTableCell>
              )}
              <StyledTableCell align="right">Amount&nbsp;</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {invoiceData?.invoiceData?.invoiceItems?.map((product, index) => {
              const discount = product.productOrCategoryDiscount ?? 0;
              let netAmount = product.amount;
              let disAmount = 0;

              if (discount > 0) {
                if (product.productOrCategoryDiscountType === 'PAYRATE') {
                  disAmount = (discount * product.quantity)
                  netAmount = product.amount - disAmount;
                } else {
                  disAmount = (product.amount * discount) / 100
                  netAmount = product.amount - disAmount;
                }
              }
              return <StyledTableRow key={product?._id}>
                <StyledTableCell component="th" scope="row" style={{ width: "80px" }}>
                  <strong>{index + 1}.</strong>
                </StyledTableCell>
                <StyledTableCell align="left">
                  <div className="row-content">
                    <p>
                      <strong>
                        {product?.manualProductName != null
                          ? product?.manualProductName
                          : '[ SAMPLE PRODUCT ]'}
                      </strong>
                    </p>
                    {invoiceData.invoiceData?.shopId?.showSerialNumber == true && product?.serialNumber ? (
                      <p>
                        <strong>{`Serial No: ${product.serialNumber}`}</strong>
                      </p>
                    ) : null}
                    {invoiceData.invoiceData?.shopId?.showWarrantyPeriod == true && product?.warrantyPeriod ? (
                      <p>
                        <strong>{`Warranty: ${product.warrantyPeriod}`}</strong>
                      </p>
                    ) : null}
                    <p>
                      <strong>
                        {!hardcodedShop && (
                          <>
                            {Util.formatNumber(product?.price)} x{" "}
                          </>
                        )}
                        {product?.quantity}{" "}
                        {product?.productType === "Units" ? "Units" : product?.productType}
                        {product.productOrCategoryDiscount != null && product.productOrCategoryDiscount > 0 && (
                          <> = {Util.formatNumber(Math.abs(product?.amount))}</>
                        )}
                      </strong>
                    </p>
                    {product.productOrCategoryDiscount != null &&
                      product.productOrCategoryDiscount! > 0 && (
                        <p style={{ color: 'gray' }}>
                          <strong>
                            {product.productOrCategoryDiscountType === 'PAYRATE' ? (
                              <>
                                Discount {Util.formatNumber(product.productOrCategoryDiscount!)} x {product.quantity} = -{Util.formatNumber(disAmount)}
                              </>
                            ) : (
                              <>
                                Discount [{product.productOrCategoryDiscount + '%'}] {Util.formatNumber(Math.abs(product.price * (product.productOrCategoryDiscount! / 100)))} x {product.quantity} = -{Util.formatNumber(disAmount)}
                              </>
                            )}
                          </strong>
                        </p>
                      )}
                  </div>
                </StyledTableCell>
                {invoiceData.invoiceData?.shopId?._id === "685fb7cb1d830c004fafc932" && (
                  <StyledTableCell align="left">
                    <div className="row-content">
                      <p>
                        <strong>
                          {product?.inventory?.brandName ?? "-"}
                        </strong>
                      </p>
                    </div>
                  </StyledTableCell>
                )}
                <StyledTableCell align="right">
                  <div className="row-content">
                    <p>
                      <strong>
                        {Util.formatNumber(Math.abs(netAmount))}{' '}
                        {invoiceData.invoiceData?.originalCurrency?.currencyName}
                      </strong>
                    </p>


                  </div>
                </StyledTableCell>
              </StyledTableRow>
            })}
          </TableBody>
        </Table>
      </TableContainer>
      {invoiceData?.invoiceData?.invoiceFreeItems?.length > 0 && (
        <p>
          <strong>Free Item/s</strong>
        </p>
      )}
      <TableContainer sx={{ maxHeight: 400, minHeight: 400 }} component={Paper}>
        <Table aria-label="customized table">

          <TableBody>
            {invoiceData?.invoiceData?.invoiceFreeItems.map((product, index) => (
              <StyledTableRow key={product?._id}>
                <StyledTableCell component="th" scope="row" style={{ width: "80px" }}>
                  <strong>{index + 1}.</strong>
                </StyledTableCell>
                <StyledTableCell align="left" >
                  <div className="row-content">
                    <p>
                      <strong>
                        {product?.manualProductName != null
                          ? product?.manualProductName
                          : '[ SAMPLE PRODUCT ]'}
                      </strong>
                    </p>
                    {invoiceData.invoiceData?.shopId?.showSerialNumber == true && product?.serialNumber ? (
                      <p>
                        <strong>{`Serial No: ${product.serialNumber}`}</strong>
                      </p>
                    ) : null}
                    {invoiceData.invoiceData?.shopId?.showWarrantyPeriod == true && product?.warrantyPeriod ? (
                      <p>
                        <strong>{`Warranty: ${product.warrantyPeriod}`}</strong>
                      </p>
                    ) : null}
                    <p>
                      <strong>
                        {Util.formatNumber(product?.price)} x {product?.quantity}{' '}
                        {product?.productType === 'Units'
                          ? ''
                          : product?.productType}
                      </strong>
                    </p>


                  </div>
                </StyledTableCell>
                {invoiceData.invoiceData?.shopId?._id === "685fb7cb1d830c004fafc932" && (
                  <StyledTableCell align="left">
                    <div className="row-content">
                      <p>
                        <strong>
                          {product?.inventory?.brandName ?? "-"}
                        </strong>
                      </p>
                    </div>
                  </StyledTableCell>
                )}
                <StyledTableCell align="right">

                </StyledTableCell>

              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      {invoiceData?.invoiceData?.returnItems?.length > 0 && (
        <p>
          <strong>Return Item/s</strong>
        </p>
      )}
      <TableContainer sx={{ maxHeight: 400, minHeight: 400 }} component={Paper}>
        <Table aria-label="customized table">

          <TableBody>
            {invoiceData?.invoiceData?.returnItems?.map((product, index) => {
              const discount = product.productOrCategoryDiscount ?? 0;
              let netAmount = product.amount;
              let disAmount = 0;

              if (discount > 0) {
                if (product.productOrCategoryDiscountType === 'PAYRATE') {
                  disAmount = (discount * product.quantity)
                  netAmount = product.amount - disAmount;
                } else {
                  disAmount = (product.amount * discount) / 100
                  netAmount = product.amount - disAmount;
                }
              }
              return <StyledTableRow key={product?._id}>
                <StyledTableCell component="th" scope="row" style={{ width: "80px" }}>
                  <strong>{index + 1}.</strong>
                </StyledTableCell>
                <StyledTableCell align="left" >
                  <div className="row-content">
                    <p>
                      <strong>
                        {product?.manualProductName != null
                          ? product?.manualProductName
                          : '[ SAMPLE PRODUCT ]'}
                      </strong>
                    </p>
                    {(invoiceData.invoiceData?.shopId?.showSerialNumber == true && product?.serialNumber) ? (
                      <p>
                        <strong>{`Serial No: ${product.serialNumber}`}</strong>
                      </p>
                    ) : null}
                    {invoiceData.invoiceData?.shopId?.showWarrantyPeriod == true && product?.warrantyPeriod ? (
                      <p>
                        <strong>{`Warranty: ${product.warrantyPeriod}`}</strong>
                      </p>
                    ) : null}
                    {(product?.returnStatus) ? (
                      <p>
                        <strong>{`${product.returnStatus}`}</strong>
                      </p>
                    ) : null}
                    <p>
                      <strong>
                        {!hardcodedShop && (
                          <>
                            {Util.formatNumber(product?.price)} x{" "}
                          </>
                        )}
                        {product?.quantity}{" "}
                        {product?.productType === "Units" ? "Units" : product?.productType}
                        {product.productOrCategoryDiscount != null && product.productOrCategoryDiscount > 0 && (
                          <> = {Util.formatNumber(Math.abs(product?.amount))}</>
                        )}
                      </strong>
                    </p>
                    {product.productOrCategoryDiscount != null &&
                      product.productOrCategoryDiscount! > 0 && (
                        <p style={{ color: 'gray' }}>
                          <strong>
                            {product.productOrCategoryDiscountType === 'PAYRATE' ? (
                              <>
                                Discount {Util.formatNumber(product.productOrCategoryDiscount!)} x {product.quantity} = -{Util.formatNumber(disAmount)}
                              </>
                            ) : (
                              <>
                                Discount [{product.productOrCategoryDiscount + '%'}] {Util.formatNumber(Math.abs(product.price * (product.productOrCategoryDiscount! / 100)))} x {product.quantity} = {Util.formatNumber(disAmount)}
                              </>
                            )}
                          </strong>
                        </p>
                      )}
                  </div>
                </StyledTableCell>
                {invoiceData.invoiceData?.shopId?._id === "685fb7cb1d830c004fafc932" && (
                  <StyledTableCell align="left">
                    <div className="row-content">
                      <p>
                        <strong>
                          {product?.inventory?.brandName ?? "-"}
                        </strong>
                      </p>
                    </div>
                  </StyledTableCell>
                )}
                <StyledTableCell align="right">
                  <div className="row-content">
                    <p>
                      <strong>
                        {Util.formatNumber(Math.abs(netAmount))}{' '}
                        {invoiceData.invoiceData?.originalCurrency?.currencyName}
                      </strong>
                    </p>



                  </div>
                </StyledTableCell>

              </StyledTableRow>
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}
